// @flow
import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#283d4b',
            light: '#374a58',
            lighter: '#d4dce7',
            contrastText: '#fff'
        }
    }
});

export default theme;
